import { Input } from "@/components/ui/input";
import { ChipGroup, Field } from "@/components/site/FormBits";
import { ADD_ONS } from "@/lib/constants";

export function AddOnPicker({ value, other, onChange, onOtherChange, testId }) {
  return (
    <Field label="Interested in any add-ons? (optional — priced by scope)">
      <div className="flex flex-col gap-3">
        <ChipGroup options={ADD_ONS} value={value} onChange={onChange} testId={testId} />
        <Input value={other} onChange={onOtherChange} maxLength={300} placeholder="Something else? Tell us what you need"
          aria-label="Other add-on" data-testid={`${testId}-other`} />
      </div>
    </Field>
  );
}
